import Big from 'big.js'
import Moment from 'moment'

import {DATE_FORMATTER} from 'constants'

export const formatWithTickSize = (num, ts): string => {
  if (!num) return
  return Big(num).toFixed(-Big(ts).e)
}

/**
 * Format a number with comma separated sections.
 *
 * @param {number | string} num the number to format
 * @param {integer} n length of decimal
 */
export const formatNumber = (num: number | string, n: number = 2) => {
  try {
    if (typeof num !== 'number' && !num) return '-'
    num = typeof num === 'number' ? num : +num
    return num.toFixed(Math.max(0, ~~n)).replace(/\d(?=(\d{3})+\.)/g, '$&,')
  } catch {
    return '-'
  }
}

export const formatDate = (date: number | string, formatter?: string = DATE_FORMATTER) => {
  if (typeof date !== 'number' && !date) return '-'
  return new Moment(date).format(formatter)
}

export const capitalizeFirstLetter = str => str && str.charAt(0).toUpperCase() + str.slice(1)

export const trim = str => str.replace(/(^\s*)|(\s*$)/g, '')

export const formatInteger = n => n.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
